import { isMobile } from 'mobile-device-detect';
import * as dayjs from 'dayjs';

export default {
  methods: {
    /**
     * Make a hyphenated string slug from the provided string, with a 
     * specified max of words length, starting from the begining of the string
     * 
     * @param {string} string
     * @param {int} maxLength
     * @returns {string}
     */
    makeSlug(string, maxLength = 2) {

      let slug = string.toLowerCase().split(' ', maxLength);
      return slug.join('-');

    },
    /** 
     * Checks if a customer id exists
    */
    isCustomer(){
      return JSON.parse(this.$store.state.auth).customer_id;
    },

    isEmptyObject(obj) {
      for(var key in obj) {
        if(obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },

    isMobile() {
      return isMobile;
    },

    stripTags( str ) {
      return str.replace(/(<([^>]+)>)/ig, "");
    },

    stripNewLines( str ) {
      return str.replace(/(?:\\[rn]|[\r\n]+)+/g, "").replace(/(?:\\[t]|[\t]+)+/g, " ");
    },
    
    /**
     * This function handles the +/- button clicks for the qty boxes
     * @param {*} event 
     */
    qtyButtonClick(event){
        event.preventDefault();
        let currentEl   = event.currentTarget;
        let input       = $(currentEl).closest('.input-group').find('input[name=qty]');
        let minusBtn    = $(currentEl).closest('.input-group').find('button[data-type=minus]');
        let plusBtn     = $(currentEl).closest('.input-group').find('button[data-type=plus]');
        let currentVal  = parseInt(input.val());

        if (!isNaN(currentVal)) {
            switch ($(currentEl).data('type')) {
                case 'minus':
                        if(currentVal > input.attr('min'))  input.val(currentVal - 1);
                        if(parseInt(input.val()) <= input.attr('min')) $(minusBtn).addClass('disabled');
                        if(parseInt(input.val()) < input.attr('max')) $(plusBtn).removeClass('disabled');
                    break;
            
                case 'plus':
                        if(currentVal < input.attr('max')) input.val(currentVal + 1);
                        if(parseInt(input.val()) >= input.attr('max')) $(plusBtn).addClass('disabled');
                        if(parseInt(input.val()) > input.attr('min')) $(minusBtn).removeClass('disabled');
                    break;
            }
        } else {
            input.val(0);
        }

        this.$emit('updateDicountedPrice', input.val());
        input[0].dispatchEvent(new Event('input'));
    },
    /**
     * Allows only numeric input
     * @param {*} event 
     */
    validateKeystroke(event){
        // Allow: backspace, delete, tab, escape, enter
        if ($.inArray(event.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
             // Allow: Ctrl+A
            (event.keyCode == 65 && event.ctrlKey === true) || 
             // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
                 // let it happen, don't do anything
                 this.$emit('updateDicountedPrice', event.currentTarget.value);
                 return;
        }
        // Ensure that it is a number and stop the keypress
        if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
            event.preventDefault();
        }
        this.$emit('updateDicountedPrice', event.currentTarget.value);
    }
  },

  filters: {
    /**
    * Returns a formatted date string in the format DD-MM-YYYY
    * @param {string} dateStr : source date string value to be formatted
    * @param {boolean} showTime : setting true will add hours and minutes to the formatted date string
    */
    formatDate(dateStr, options = { showTime: false, isString: false, format: 'DD-MM-YYYY' }) {
      try {
        const showTime = options && options.showTime ? options.showTime : false;
        
        if ( showTime )
          return dayjs(dateStr).format('DD-MM-YYYY HH:mm');
        
        if ( options && options.format == 'YYYY-MM-DD' ) 
          return dayjs(dateStr).format('YYYY-MM-DD');

        return dayjs(dateStr).format('DD-MM-YYYY');
      } catch (err) {
        console.error( err);
        return '';
      }
    }
  }
}